let lastScrollTopPos = 0;

function setHeaderPosition(){
    const stickyHeader = $('.js-header-sticky');
    let wST = $(window).scrollTop();

    if(wST > stickyHeader.height()){
        if (wST > lastScrollTopPos) {
            // SCROLL DOWN
            stickyHeader.removeClass('is-sticky');

            if($('.js-favorites-tabs-container').length){
                setFavoritesTabsPosition('down');
            }
        } else {
            // SCROLL UP
            stickyHeader.addClass('is-sticky');

            if($('.js-favorites-tabs-container').length){
                setFavoritesTabsPosition('up');
            }
        }
    }

    lastScrollTopPos = wST;
}
  
runIfElementExist(setHeaderPosition, '.js-header-sticky')
  
$(window).on("scroll", function () {
    setHeaderPosition();
});
